import { ReactNode, useState } from 'react'
import { PrequalModal } from './PrequalModal'
import { Button, ButtonProps } from '@homebotapp/hb-react-component-catalog'
import { selectClientIsGuest } from '../../../../store/selectors/client'
import { useDispatch, useSelector } from 'react-redux'
import { toggleAuthModal } from '../../../../actions/homeSearchAuthModal'
import { Listing } from '../../../../api/gqlaxy/gql/generated/graphql'

interface PrequalCtaButtonProps extends ButtonProps {
  ctaButtonVariant?: 'ghost' | 'outline' | 'solid'
  ctaButtonColorScheme: 'primary' | 'secondary' | 'brand'
  ctaButtonSize: 'xs' | 'sm' | 'md'
  listing?: Listing
  className?: string
  leftIcon?: React.ReactElement
  fullWidth?: boolean
  children: ReactNode & Omit<ReactNode, 'null' | 'undefined'> // the intl'd button text
  uiContext: string
  customPrequalMessage?: string
}

export const PrequalCtaButton = ({
  ctaButtonVariant,
  ctaButtonColorScheme,
  ctaButtonSize,
  className,
  children,
  listing,
  leftIcon,
  fullWidth,
  uiContext,
  customPrequalMessage,
  ...props
}: PrequalCtaButtonProps) => {
  const [isCtaModalOpen, setIsCtaModalOpen] = useState(false)
  const isGuest = useSelector(selectClientIsGuest)
  const dispatch = useDispatch()

  return (
    <>
      <Button
        data-qa={'Prequal'}
        className={className}
        onClick={() => {
          if (isGuest) {
            dispatch(toggleAuthModal(true))
          } else setIsCtaModalOpen(true)
        }}
        leftIcon={leftIcon}
        size={ctaButtonSize}
        colorScheme={ctaButtonColorScheme}
        variant={ctaButtonVariant}
        width={fullWidth ? '100%' : ''}
        {...props}
      >
        {children}
      </Button>
      <PrequalModal
        listing={listing}
        uiContext={uiContext}
        isOpen={isCtaModalOpen}
        customPrequalMessage={customPrequalMessage}
        handleClose={() => setIsCtaModalOpen(false)}
      />
    </>
  )
}
